import styled from "styled-components";
import { alpha, styled as muiStyled } from "@mui/system";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

const ODD_OPACITY = 0.2;

const DataTableDivContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 50vh;
`;

const StyledDataGrid = muiStyled(
  DataGrid,
  {}
)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.white.main,
    "&:hover, &.Mui-hovered": {
      backgroundColor: alpha(theme.palette.white.main, ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "white",
      },
    },
  },
  "& .MuiDataGrid-columnSeparator": {
    visibility: "hidden",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#354A55",
    color: "#fff",
    "& .MuiCheckbox-root": {
      color: "#fff",
    },
    "& .MuiButtonBase-root": {
      color: "#fff",
    },
  },
  "&.MuiDataGrid-root": {
    border: "0px",
  },
  "& .MuiDataGrid-main": {
    boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
  },
  "& .MuiTablePagination-displayedRows": {
    margin: "unset",
  },
  "& .MuiTablePagination-selectLabel": {
    visibility: "hidden",
  },

}));

export { StyledDataGrid, DataTableDivContainer };
